import { envConfig } from '~/utils/env';
import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type {
  ApproveManualJournalEntryRequestDto,
  CreateManualJournalEntryRequestDto,
  GetManualJournalEntriesParams,
  ManualJournalEntryDto,
  ManualJournalEntryPaginationDto,
  PostManualJournalEntryRequestDto,
  RejectManualJournalEntryRequestDto,
  SubmitManualJournalEntryRequestDto,
  UpdateManualJournalEntryRequestDto,
} from '~/swagger/accounting/Api';

const BASE_URL = `${envConfig.service.accounting}/company-portal/manual-journal-entries`;

export class ManualEntriesRepository extends BaseRestRepository {
  public async createManualJournalEntry(payload: CreateManualJournalEntryRequestDto): Promise<ManualJournalEntryDto> {
    const url = BASE_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async getManualJournalEntries(filter?: GetManualJournalEntriesParams): Promise<ManualJournalEntryPaginationDto> {
    const url = urlWithQuery(`${BASE_URL}`, filter);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getManualJournalEntry(manualJournalEntryId: string): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateManualJournalEntry(
    manualJournalEntryId: string,
    payload: UpdateManualJournalEntryRequestDto
  ): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteManualJournalEntry(manualJournalEntryId: string): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }

  public async submitManualJournalEntry(
    manualJournalEntryId: string,
    payload: SubmitManualJournalEntryRequestDto
  ): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}/submit`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async approveManualJournalEntry(
    manualJournalEntryId: string,
    payload: ApproveManualJournalEntryRequestDto
  ): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}/approve`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }
  public async rejectManualJournalEntry(
    manualJournalEntryId: string,
    payload: RejectManualJournalEntryRequestDto
  ): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}/reject`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }
  public async postManualJournalEntry(
    manualJournalEntryId: string,
    payload: PostManualJournalEntryRequestDto
  ): Promise<ManualJournalEntryDto> {
    const url = `${BASE_URL}/${manualJournalEntryId}/post`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }
}
